import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import ConfigurationsSubgradesService from "../../../../services/api/configurations/ConfigurationsSubgrades.service";
import { RefreshReactQuery } from "../../../../constants/AppConstants";
import { useNotification } from "../../../notification.hook";
import { UpdateSubgradesConfig } from "../../../../types/api/configurations.type";
import {
  DATA_SAVED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../../../constants/Dictionary";
import { useEffect } from "react";

const MANAGE_SUBGRADES_QUERY_KEY = "get-config-subgrades";

export const useManageSubgrades = (configYear: number) => {
  const { notification } = useNotification();
  const { data, isFetching, isError } = useQuery({
    queryKey: [MANAGE_SUBGRADES_QUERY_KEY, configYear],
    queryFn: () => ConfigurationsSubgradesService.list(),
    staleTime: RefreshReactQuery.MODERATE,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isFetching };
};

export const useUpdateManageSubgrades = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationKey: ["update-manage-subgrades"],
    mutationFn: (result: UpdateSubgradesConfig) =>
      ConfigurationsSubgradesService.update(result),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MANAGE_SUBGRADES_QUERY_KEY],
      });
      notification.success(DATA_SAVED_SUCCESS_LABEL, undefined, "toast");
    },
    onError: (error) => {
      console.error(`errore updating sugrades config: ${error}`);
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });
  return { mutate, isPending };
};
